<template>
  <svg
    width="24"
    height="24"
    viewBox="35 0 52 80"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        fill="currentColor"
        fill-rule="nonzero"
      >
        <g>
          <path
            d="M84.6923594,50.0126659 C84.2791761,46.6360509 83.1784831,43.4743552 81.5320866,40.6701293 L60.4997269,0 L39.4666024,40.6701293 L39.4681319,40.6701293 C37.8205337,43.4743552 36.7213701,46.6361603 36.3084054,50.0126659 L36.3084054,50.0140871 C36.2517047,50.4773768 36.2060382,50.9454766 36.1745742,51.4175118 C36.173154,51.4539147 36.1703135,51.4919574 36.1668175,51.5293441 C36.1372107,52.017777 36.119403,52.5073031 36.119403,53.0028417 C36.119403,66.4773808 47.0344544,77.4 60.4998361,77.4 C73.9648901,77.4 84.880597,66.4773808 84.880597,53.0028417 C84.880597,52.5074124 84.862243,52.0178863 84.8311068,51.5293441 C84.8283755,51.491848 84.8254258,51.454024 84.8226946,51.4175118 C84.7922138,50.9454766 84.7476398,50.4773768 84.6926871,50.0140871 L84.6926871,50.0126659 L84.6923594,50.0126659 Z"
          />
        </g>
      </g>
    </g>
  </svg>
</template>
